<form [formGroup]="form">
  <mat-form-field>
    <mat-label>Strategy Type</mat-label>
    <mat-select formControlName="strategyType" placeholder="" (selectionChange)="onStrategyTypeChange($event)">
      @for (item of captureToolTypes; track item) {
        <mat-option [value]="item.value">{{item.label}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>

@if (showIncentive) {
  <div fxLayout="row" fxLayoutGap="150px">
    <mat-form-field>
      <mat-label>Incentive Base</mat-label>
      <mat-select [(ngModel)]="baseCalculation" placeholder="" (selectionChange)="onBaseCalculationChange($event)">
        @for (item of baseCalculationList; track item) {
          <mat-option [value]="item.value">{{item.label}}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (baseCalculation == 'ValueBased') {
      <mat-form-field>
        <mat-label>Currency</mat-label>
        <mat-select [(ngModel)]="currencyCode" placeholder="" (selectionChange)="onCurrencyChange($event)">
          @for (item of currencyList; track item) {
            <mat-option [value]="item.value">{{item.label}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
}
@if (strategyType) {
  <div fxLayout="column" class="mat-typography reward-select-wrapper" fxLayoutGap="20px">
    <div fxLayout="column">
      <app-reward-select #joinReward [advertiserId]="advertiserId" [title]="'Instant win for joining campaign'">
      </app-reward-select>
    </div>
    <div fxLayout="column">
      <app-reward-select #firstConsumptionReward [advertiserId]="advertiserId"
      [title]="'Instant win for the first ' +  (strategyType == 'Stamps' ? 'stamp' : 'point')"></app-reward-select>
    </div>
    <div fxLayout="column">
      <app-reward-select #consumptionReward [advertiserId]="advertiserId" [title]="'Instant win for any consumption'">
      </app-reward-select>
    </div>
    <div fxLayout="column">
      <app-reward-select #birthdayReward [advertiserId]="advertiserId" [title]="'Birthday reward'">
      </app-reward-select>
    </div>
  </div>
  <div fxLayout="row" [style.marginBottom.px]="10">
    <div fxLayout="column" class="text-right">
      <lib-button (buttonClick)="addScheme()" icon="add">Add Scheme</lib-button>
    </div>
  </div>

  @if (punchCardCampaignService.captureToolType !== 'UniqueSafebox') {
    @if (schemeList?.length) {
      <mat-accordion id="schemeList" class="scheme-list">
        @for (scheme of schemeList; track scheme) {
          @if (scheme) {
          <mat-expansion-panel [expanded]="scheme['index']==schemeList.length-1" (opened)="scheme['opened'] = true"
            (closed)="scheme['opened'] = false">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{scheme.name}}
              </mat-panel-title>
              @if (scheme['opened']) {
                <mat-panel-description>
                  <lib-button icon="delete" (buttonClick)="removeScheme($event, scheme)">Remove Scheme</lib-button>
                </mat-panel-description>
              }
            </mat-expansion-panel-header>
            <app-punch-card-scheme [strategyType]="strategyType" [captureToolType]="captureToolType" [advertiserId]="advertiserId" [scheme]="scheme" [campaignId]="campaignId" (onSchemeChanged)="onSchemeChange($event, scheme)" />
          </mat-expansion-panel>
          }
        }
      </mat-accordion>
    } @else {
      <p class="error">You have to add at least one scheme*</p>
    }
  }
  <br>
}
